export const initIDBRetentionWorker = () => {
  if (!window.Worker) return;

  const exploreWarmTierRetentionWorker = new Worker(new URL('./index-db.retention.worker', import.meta.url), {
    type: 'module',
  });

  exploreWarmTierRetentionWorker.postMessage('');
};
